import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  get<T>(key: string): T | null {
  const value = sessionStorage.getItem(key);
  try {
    return value ? (JSON.parse(value) as T) : null;
  } catch {
    return value as unknown as T; // fallback if it's just a string/number
  }
}

set<T>(key: string, value: T): void {
  sessionStorage.setItem(key, typeof value === 'string' ? value : JSON.stringify(value));
}

remove(key: string): void {
  sessionStorage.removeItem(key);
}

clear(): void {
  sessionStorage.clear();
}
}